export default __webpack_public_path__ + "static/ovulo-e7835e7b6ae896da85348d9f2f7eb92d.png";